export default "__VITE_ASSET__BHKCkQyA__"